import { collection, getDocs, addDoc, updateDoc, doc, setDoc } from 'firebase/firestore';
import { db } from './config';
import { verifyAdmin } from './auth';
import type { Settings } from '../../types/course';
import { cleanObject } from '../utils';

export async function fetchSettings() {
  try {
    const settingsCol = collection(db, 'settings');
    const snapshot = await getDocs(settingsCol);
    
    // Si aucun paramètre n'existe, créer les paramètres par défaut
    if (snapshot.empty) {
      const defaultSettings: Settings = {
        logo: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&q=80&w=100',
        categories: ['Modélisation', 'Animation', 'Texturing', 'Rendu'],
        pageTitle: 'Les Créateurs 3D - Formations',
        tags: ['Blender', '3D', 'Animation', 'Débutant', 'Professionnel', 'Texturing', 'Rendu']
      };
      
      const docRef = doc(db, 'settings', 'default');
      await setDoc(docRef, defaultSettings);
      return defaultSettings;
    }
    
    return snapshot.docs[0].data() as Settings;
  } catch (error) {
    console.error('Erreur lors du chargement des paramètres:', error);
    return null;
  }
}

export async function saveSettings(settings: Settings) {
  try {
    await verifyAdmin();
    const cleanedSettings = cleanObject(settings);

    const settingsCol = collection(db, 'settings');
    const snapshot = await getDocs(settingsCol);
    
    if (snapshot.empty) {
      const docRef = doc(db, 'settings', 'default');
      await setDoc(docRef, cleanedSettings);
    } else {
      await updateDoc(snapshot.docs[0].ref, cleanedSettings);
    }
  } catch (error) {
    console.error('Erreur lors de la sauvegarde des paramètres:', error);
    throw error;
  }
}